import React from 'react';
import { useApp } from '../context/AppContext';

const LiveTVPage = () => {
    const { settings } = useApp();

    return (
        <div className="page" style={{ textAlign: 'center', padding: '40px 20px' }}>
            <div className="tag">LIVE</div>
            {/* <h2 style={{ fontFamily: 'var(--ff-head)', fontSize: '32px', margin: '12px 0' }}>BharatNews Live TV</h2> */}
            <p style={{ color: 'var(--gray)', marginBottom: '20px' }}>Watch live news coverage, debates, and special programmes.</p>
            <div style={{ background: '#000', width: '100%', maxWidth: '800px', height: '450px', margin: 'auto', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '18px' }}>
                {settings.stream ? (
                    <iframe src={settings.stream} style={{ width: '100%', height: '100%', border: 'none' }} title="Live Stream" allowFullScreen></iframe>
                ) : (
                    <>📺 Live Stream Player<br /><small style={{ opacity: 0.5, fontSize: '13px' }}>Embed your live stream URL in the Admin → Settings</small></>
                )}
            </div>
        </div>
    );
};

export default LiveTVPage;